module.exports = __webpack_public_path__ + "img/steder_lapper_Sauda.751f4e47.png";